export enum AttachmentTypeChannel {
  CREATE = 'attachmentType::create',
  EDIT = 'attachmentType::patch',
  DELETE = 'attachmentType::delete',
}
